import styled, { css } from 'styled-components'
import { colors } from 'config/ui'
import { tokens } from '@arvoreeducacao/bonsai-ds'

interface StyledAvatarProps {
  image: string
  size: 'medium' | 'big' | 'xbig' | 'xxbig'
}

export const StyledAvatar = styled.div<StyledAvatarProps>`
  ${({ image, size }) => css`
    ${['width', 'min-width', 'height', 'min-height'].map(
      attr => `
      ${attr}: ${
        size === 'medium'
          ? '30px'
          : size === 'big'
          ? '40px'
          : size === 'xbig'
          ? '120px'
          : size === 'xxbig'
          ? '140px'
          : '45px'
      };
    `
    )} border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    color: ${colors.avatarText};
    font-weight: ${size === 'xxbig' ? '300' : '700'};
    ${image
      ? `background: url(${image}) no-repeat;`
      : `background-color: ${colors.avatarBg};`} background-size: cover;
    background-position: center;

    font-size: ${size === 'medium'
      ? '16px'
      : size === 'big'
      ? '16px'
      : size === 'xbig'
      ? '16px'
      : size === 'xxbig'
      ? '40px'
      : '16px'};
  `};
`

export const AvatarBullet = styled.div`
  border-radius: ${tokens.radius.circular};
  height: 16px;
  width: 16px;
  background-color: ${tokens.colors.error};
  color: ${tokens.colors.white};
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const AvatarBulletWrapper = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  padding: 2px;
  border-radius: ${tokens.radius.circular};
  background-color: white;
`

export const AvatarWrapper = styled.div`
  position: relative;
  margin-right: 4px;
  cursor: pointer;
`
